<template>
  <header class="subHeader">
    <div class="content-header">ARCHIVE</div>
    <div class="content-body">Events that have taken place are automatically moved here.</div>
  </header>
</template>
<script>
export default {
  name: 'subHeaderArchive',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderArchive.vue?2f6abe44